module.exports = __webpack_public_path__ + "static/us_oregon_tilth-e1533a0d3f0861990ab2aeeadfb0eab2.png";